import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live/canada'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'
import { subtitleText } from 'src/modules/utils/constants'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'Premier League TV',
    callsign: 'PRLITVGD',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress',
    slug: 'epl',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        callsign="PRLITVGD"
        // background="https://assets-imgx.fubo.tv/marketing/lp/images/posters/onebox-epl.png?w=1920&ch=width&auto=format,compress"
        title="Watch Premier League All Season"
        subtitle={subtitleText.epl}
        networkSet="canada_sports"
        customNetworks={['fsn']}
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
        logoHeight="90px"
        networkName="Premier League TV"
        planCardsConfig={{
          plans: canadaPlanSet.sports,
          overrides: canadaSports_EPL_UCL_Override,
        }}
      />
    </>
  )
}
